import { useContext } from 'react';
import { AppContext } from '../App';
import { AppContext as MainAppContext } from '../../App';
import { GameContext } from '../boards/LastcardBoard';
import logo_wide from '../assets/logo_wide.png';
import { 
  BsFillSuitDiamondFill,
  BsFillSuitHeartFill,
  BsSuitClubFill,
  BsFillSuitSpadeFill,
} from 'react-icons/bs'


export default function CardRequester(props) {

  const app = useContext(AppContext);
  const mainApp = useContext(MainAppContext);
  const gameContext = useContext(GameContext);

  function clicked(e) {
    e.stopPropagation();
  }

  if(gameContext.showCardRequester) {
    //...
    return (
      <div className='CorePaper coreShadow' onClick={clicked}>
        <div className='text-center'>
          <h5 style={{ fontSize: "20px" }}>
            Call For Card<br/>
            <span className='font-semi-bold text-muted' style={{ fontSize: "15px" }}>Omba karata</span>
          </h5>

          <div
            style={{
              width: "100%",
            }}
            className='text-start'
          >
            <h6 className='text-muted font-light' style={{ fontSize: "12px", marginTop: "20px" }}>Select below</h6>

            <div className='row font-bold'>
              <div className='col-4' style={{ marginBottom: "10px" }}>
                <button
                  className={(gameContext.cardRequest && gameContext.cardRequest.required === 'special') ? 'btn btn-sm core-bg-goldish' : 'btn btn-sm core-bg-whitish'}
                  style={{
                    height: "100%",
                    width: "100%",
                    margin: "0",
                  }}
                  onClick={() => {
                    gameContext.ombaKarata('special')
                  }}
                >
                  Special Card
                </button>
              </div>

              <div className='col-4' style={{ marginBottom: "10px" }}>
                <button
                  className={(gameContext.cardRequest && gameContext.cardRequest.required === 'kisu') ? 'btn btn-sm core-bg-goldish' : 'btn btn-sm core-bg-whitish'}
                  style={{
                    height: "100%",
                    width: "100%",
                    margin: "0",
                  }}
                  onClick={() => {
                    gameContext.ombaKarata('kisu')
                  }}
                >
                  <BsFillSuitDiamondFill color="red" size={30}/>
                </button>
              </div>

              <div className='col-4' style={{ marginBottom: "10px" }}>
                <button
                  className={(gameContext.cardRequest && gameContext.cardRequest.required === 'karanga') ? 'btn btn-sm core-bg-goldish' : 'btn btn-sm core-bg-whitish'}
                  style={{
                    height: "100%",
                    width: "100%",
                    margin: "0",
                  }}
                  onClick={() => {
                    gameContext.ombaKarata('karanga')
                  }}
                >
                  <BsSuitClubFill color="black" size={30}/>
                </button>
              </div>

              <div className='col-4' style={{ marginBottom: "10px" }}>
                <button
                  className={(gameContext.cardRequest && gameContext.cardRequest.required === 'any') ? 'btn btn-sm core-bg-goldish' : 'btn btn-sm core-bg-whitish'}
                  style={{
                    height: "100%",
                    width: "100%",
                    margin: "0",
                  }}
                  onClick={() => {
                    gameContext.ombaKarata('any')
                  }}
                >
                  Any Card
                </button>
              </div>

              <div className='col-4' style={{ marginBottom: "10px" }}>
                <button
                  className={(gameContext.cardRequest && gameContext.cardRequest.required === 'jembe') ? 'btn btn-sm core-bg-goldish' : 'btn btn-sm core-bg-whitish'}
                  style={{
                    height: "100%",
                    width: "100%",
                    margin: "0",
                  }}
                  onClick={() => {
                    gameContext.ombaKarata('jembe')
                  }}
                >
                  <BsFillSuitSpadeFill color="black" size={30}/>
                </button>
              </div>

              <div className='col-4' style={{ marginBottom: "10px" }}>
                <button
                  className={(gameContext.cardRequest && gameContext.cardRequest.required === 'kopa') ? 'btn btn-sm core-bg-goldish' : 'btn btn-sm core-bg-whitish'}
                  style={{
                    height: "100%",
                    width: "100%",
                    margin: "0",
                  }}
                  onClick={() => {
                    gameContext.ombaKarata('kopa')
                  }}
                >
                  <BsFillSuitHeartFill color="red" size={30}/>
                </button>
              </div>

            </div>
          </div>


          <div className='row' style={{ marginTop: "30px" }}>
            
            <div className='col-12 text-end'>
              <button
               className='btn'
               style={{
                background: "var(--core-blackish)",
                color: "var(--core-whitish)",
               }}
               onClick={() => gameContext.setShowCardRequester(false)}
              >
                {
                  (gameContext.cardRequest && gameContext.cardRequest.required) ?
                  "Okay" : "Close"
                }
              </button>
            </div>
          </div>
        </div>
      </div>
    )
    //...
  }
}